// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { init, browserTracingIntegration } from "@sentry/nextjs";

import EventScrubber from "@stadium/services/sentry-nextjs/integration";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

/**
 * Generates a Sentry initialisation config
 * @param {Object} options - The options for the Sentry initialisation config
 * @param {string[]|RegExp[]} options.whitelistedUrls - The URLs to whitelist
 * @returns {Object} The Sentry initialisation config
 */
export const generateSentryInitialisationConfig = ({
  whitelistedUrls = [process.env.PUBLIC_URL],
} = {}) => ({
  dsn: SENTRY_DSN,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.5,
  normalizeDepth: 11,
  integrations: [new EventScrubber(), browserTracingIntegration()],
  allowUrls: whitelistedUrls,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});

export const initialiseClient = (config = generateSentryInitialisationConfig()) => {
  if (!config.dsn) {
    return null;
  }
  return init(config);
};
